import { PartTypeSchema, PartTypeType } from "../types";

export const isSheetPartType = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return true;
  }

  switch (partType) {
    case PartTypeSchema.enum.SHEET:
      return true;
    default:
      return false;
  }
};
